import type { CmsPage } from './apiTypes';
import { fetchCmsPages } from './cmsApi';
import { findCmsPageByMetaTitle, resolveCmsPageLocalizedHtml } from './cmsHelpers';

export const HEALTH_INFORMATION_CMS_META_TITLE = 'health_information';

export const healthInformationCmsQueryKey = ['cms', HEALTH_INFORMATION_CMS_META_TITLE] as const;

export type HealthInformationAppLanguage = 'en' | 'ar';

export function findHealthInformationCmsPage(pages: CmsPage[] | null | undefined): CmsPage | null {
  return findCmsPageByMetaTitle(pages, HEALTH_INFORMATION_CMS_META_TITLE);
}

export function resolveHealthInformationCmsHtml(
  page: CmsPage | null,
  language: HealthInformationAppLanguage,
): string {
  return resolveCmsPageLocalizedHtml(page, language);
}

export function isHealthInformationCmsPageAvailable(
  page: CmsPage | null,
  language: HealthInformationAppLanguage,
): boolean {
  return Boolean(page) && resolveHealthInformationCmsHtml(page, language).length > 0;
}

export function resolveHealthInformationCmsPageTitle(page: CmsPage | null): string {
  const title = page?.title;
  return typeof title === 'string' ? title.trim() : '';
}

export async function fetchHealthInformationCmsPage(language: HealthInformationAppLanguage) {
  const pages = await fetchCmsPages();
  const page = findHealthInformationCmsPage(pages);
  const html = resolveHealthInformationCmsHtml(page, language);
  return {
    page,
    html,
    isAvailable: Boolean(page) && html.length > 0,
    pageTitle: resolveHealthInformationCmsPageTitle(page),
  };
}
